import { ExtendableRadioOption } from '@zuto/molecules'

const employmentStatusOptionsSideBySide: ExtendableRadioOption[] = [
  {
    value: 'full time permanent',
    label: 'Full Time Permanent'
  },
  {
    value: 'self employed',
    label: 'Self Employed'
  },
  {
    value: 'not employed',
    label: 'Not Employed'
  },
  {
    value: 'student',
    label: 'Student'
  },
  {
    value: 'part time',
    label: 'Part Time'
  },
  {
    value: 'disability',
    label: 'Disability'
  },
  {
    value: 'agency',
    label: 'Agency',
    hidden: true
  },
  {
    value: 'retired',
    label: 'Retired',
    hidden: true
  },
  {
    value: 'sub contractor',
    label: 'Subcontractor',
    hidden: true
  },
  {
    value: 'temporary',
    label: 'Temporary',
    hidden: true
  },
  {
    value: 'armed forces',
    label: 'Armed Forces',
    hidden: true
  },
  {
    value: 'homemaker',
    label: 'Homemaker',
    hidden: true
  },
  {
    value: 'carer',
    label: 'Carer',
    hidden: true
  },
  {
    value: 'other',
    label: 'Other',
    hidden: true
  }
]

export default employmentStatusOptionsSideBySide
